module.exports = __webpack_public_path__ + "assets/can-edit.59c4addb.svg";